import { render, staticRenderFns } from "./ComponentConteudoNossosProdutos.vue?vue&type=template&id=a57d401a&scoped=true&"
import script from "./ComponentConteudoNossosProdutos.vue?vue&type=script&lang=js&"
export * from "./ComponentConteudoNossosProdutos.vue?vue&type=script&lang=js&"
import style0 from "./ComponentConteudoNossosProdutos.vue?vue&type=style&index=0&id=a57d401a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57d401a",
  null
  
)

export default component.exports